import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import FuelContractsContainer from '../../containers/inventory/FuelContracts';
import { valueToDisplay } from '../../libs/products';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';

let renderCount = 0;

const sixMonthsAgo = moment().subtract(6, 'months');

class FMPFuelContractPicker extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { fuelContracts, searchFuelContracts } = this.props;
		if (!fuelContracts) {
			searchFuelContracts({ params: {} });
		}
	}

	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			fuelContracts,
			contained,
		} = this.props;

		const hasError = !!error;

		const _onChange = (event, onChangeValue) => {
			if (_.isEmpty(onChangeValue)) {
				onChange('', path);
				return;
			}
			return onChange(onChangeValue.value, path);
		};

		let content;
		if (!fuelContracts) {
			content = (
				<Grid item xs={12} md={md}>
					<FormControl fullWidth={true} error={hasError}>
						<InputLabel htmlFor={path}>{label}</InputLabel>
						Loading fuel contracts...
					</FormControl>
				</Grid>
			);
		} else {
			const options = [];

			_.orderBy(fuelContracts, ['quarter', 'sourceCustomer'], 'desc').forEach((fuelContract) => {
				const { fuelContractId, sourceCustomer, endDate } = fuelContract;
				const display = sourceCustomer;
				if (moment(endDate).isBefore(sixMonthsAgo)) {
					return;
				}
				options.push({ value: fuelContractId, display, fuelContract });
			});

			if (renderCount++ >= 1000) {
				return console.error('max render counter');
			}
			const selectedOption = _.find(options, { value });
			content = (
				<Grid item xs={12} md={md}>
					<FormControl fullWidth={true} error={hasError}>
						<Autocomplete
							ListboxProps={{ style: { maxHeight: '30rem' } }}
							multiple={false}
							options={options}
							value={selectedOption}
							onChange={_onChange}
							getOptionLabel={this.renderOptionLabel}
							getOptionSelected={(option, value) => {
								return option.value === value.value;
							}}
							renderOption={this.renderOption}
							renderInput={(params) => (
								<TextField {...params} label={label} placeholder="Type to search" fullWidth />
							)}
						/>

						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			);
		}

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}

	renderOption = (option) => {
		const { terminalMap, supplierMap } = this.props;

		const sub = {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		};

		const { fuelContract } = option;
		const {
			fuelContractId,
			allocatedForTerminalId,
			supplierForTerminalId,
			sourceCustomer,
			contractNumber,
			quarter,
			productType,
		} = fuelContract;

		const supplier = supplierMap[supplierForTerminalId] || { name: 'Missing' };
		const terminal = terminalMap[allocatedForTerminalId] || { name: 'Missing' };
		const fuelDisplay = valueToDisplay(productType);

		return (
			<div
				key={fuelContractId}
				value={fuelContractId}
				style={{ borderBottom: '1px solid #ccc', width: '100%', padding: '5px' }}
			>
				<div>
					{quarter} : {sourceCustomer} ({contractNumber})
				</div>
				<div style={sub}>
					{fuelDisplay} @ {terminal.name} / {supplier.name}
				</div>
			</div>
		);
	};

	renderOptionLabel = (option) => {
		const { terminalMap, supplierMap } = this.props;
		const { fuelContract } = option;
		const {
			allocatedForTerminalId,
			supplierForTerminalId,
			sourceCustomer,
			contractNumber,
			quarter,
			productType,
		} = fuelContract;

		const supplier = supplierMap[supplierForTerminalId] || { name: 'Missing' };
		const terminal = terminalMap[allocatedForTerminalId] || { name: 'Missing' };
		const fuelDisplay = valueToDisplay(productType);

		return `${quarter} : ${sourceCustomer} (${contractNumber}) - ${fuelDisplay} @ ${terminal.name} / ${supplier.name}`;
	};
}

FMPFuelContractPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	fuelContracts: PropTypes.array,
	searchFuelContracts: PropTypes.func.isRequired,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,

	contained: PropTypes.bool,
	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
};

FMPFuelContractPicker.defaultProps = {
	label: 'Fuel Contract',
	readOnly: false,
	contained: true,
	md: 12,
};

export default _.flow([FuelContractsContainer])(FMPFuelContractPicker);
